import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  makeStyles,
  TextField,
  Typography
} from '@material-ui/core';
import {
  CropFree as CropFreeIcon,
  ImageSearch as ImageSearchIcon,
  ConfirmationNumber as QuantityIcon,
  Send as SendIcon
} from '@material-ui/icons';
import { useCallback, useState } from 'react';
import logger from 'src/utils/logger';

import Autocomplete from '@material-ui/lab/Autocomplete';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser, safeRequestParam } from 'src/utils/Common';
import BarkodPopup from '../../components/BarcodePopup';
import ProductMaterialSearch from '../../components/Selects/ProductMaterialSearch';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%'
  },
  cardTitle: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  actionArea: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    gap: theme.spacing(2)
  },

  barcodeButton: {
    backgroundColor: theme.palette.info.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    }
  },
  loaderWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 10
  }
}));

function MaterialRequest() {
  const classes = useStyles();
  const [MalzemeDataResim, setMalzemeDataResim] = useState({});
  const [Adet, setAdet] = useState('');
  const [MalzemeStokNo, setMalzemeStokNo] = useState('');
  const [SearchParamDetail, setSearchParamDetail] = useState('');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = useState("");
  const [open, setOpen] = useState(false);
  const [KUL_MODEL_KODU, setKUL_MODEL_KODU] = useState("0");
  const [MalzemeData, setMalzemeData] = useState([]);
  const [MalzemeStokNoTekil, setMalzemeStokNoTekil] = useState('');
  const [ModelData, setModelData] = useState([]);
  const SessionUser = getUser();

  const handleClose = () => setOpen(false);

  const setMalzemeImage = useCallback((param) => {
    setMalzemeDataResim(param);
    setMalzemeStokNo(param.MALZEME_STOK_NO);
  }, []);

  const SendMaterialImageDetail = async () => {

    if (!Adet || !MalzemeStokNo) {
      setUyari(!MalzemeStokNo ? "Lütfen malzeme seçiniz!" : "Lütfen adet giriniz!");
      setOpen(true);
      return;
    }

    setLoading(true);
    try {
      await axios.get(`/SetArtemisMaterialsWarehouse/${MalzemeStokNo}/${Adet}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`);
      setUyari("İşleminiz başarı ile gerçekleştirildi.");
    } catch (err) {
      setUyari("Bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setOpen(true);
      setLoading(false);
    }
  };

  const malzemeGosterResim = (materialCode) => {
    if (!materialCode) return;

    setLoading(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/FileImportExport/ArtemisMalzeme', { MALZEME_STOK_NO: materialCode ? materialCode.toString().trim() : "0" }, config)
      .then(response => {
        const fileURL = URL.createObjectURL(response.data);
        const win = window.open(fileURL, '_blank');
        // GÜVENLİ KONTROL: win varsa focus yap
        if (win) {
          win.focus();
        } else {
          // Eğer tarayıcı popup'ı engellediyse kullanıcıyı bilgilendir
          setUyari("Resim penceresi tarayıcı tarafından engellendi. Lütfen popup izinlerini kontrol edin.");
          setOpen(true);
        }
      })
      .catch(err => {
        logger.error("Resim yüklenirken hata:", err);
        setUyari("Resim yüklenemedi.");
        setOpen(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleGet = () => {
    setLoading(true);
    setKUL_MODEL_KODU("0");
    axios.get('/GetDepoTalepUrun/' + SessionUser.ServiceShopId + '/' + SessionUser.TechnicianId)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setModelData([]);
        } else {
          setModelData(Data);
        }
        setLoading(false);
      }).catch(error => {
        setModelData([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });

  }

  useState(() => {
    handleGet();
  }, []);



  const handleBarkodClose = async barkod => {
    if (!barkod || barkod.length === undefined) {
      setOpenBarkod(false);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(`/GetArtemisProductMaterials/${safeRequestParam(barkod)}/-1`);
      if (response.data && response.data.length > 0) {
        const bulunanMalzeme = response.data[0]; // İlk eşleşen malzemeyi al
        setKUL_MODEL_KODU('0');
        setMalzemeDataResim(bulunanMalzeme); // Artık içinde ACIKLAMA da var
        setMalzemeStokNo(bulunanMalzeme.MALZEME_STOK_NO);
        setSearchParamDetail(barkod);
      } else {
        setUyari("Okutulan barkod sistemde bulunamadı.");
        setOpen(true);
      }
    } catch (err) {
      logger.error("Barkod aranırken hata oluştu", err);
    } finally {
      setLoading(false);
      setOpenBarkod(false);
    }
  };


  const handleChangeModel = (e) => {
    setMalzemeStokNoTekil('');
    setMalzemeStokNo('');
    setKUL_MODEL_KODU(e.target.value);
    setLoading(true);
    try {
      axios.get(`/GetArtemisProductMaterials/-1/${safeRequestParam(e.target.value)}`).then(response => {
        if (response.data && response.data.length > 0) {
          setMalzemeData(response.data);
        } else {
          setMalzemeData([]);
        }
        setLoading(false);
      }).catch(error => {
        setMalzemeData([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);

      });
    } catch (err) {
      setMalzemeData([]);
      setLoading(false);
    }
  };

  const handleChangeMalzeme = (e) => {
    setMalzemeStokNoTekil(e.target.value);
    setMalzemeStokNo(e.target.value);
  };

  return (
    <Page className={classes.root} title="Malzeme Talep İşlemleri">
      <Container maxWidth="md">
        <Header />
        <Card elevation={3} style={{ position: 'relative' }}>
          <Box className={classes.cardTitle}>
            <Typography variant="h6" color="textPrimary">
              Açık Fiş Bilgileri
            </Typography>
          </Box>
          <Divider />
          <CardContent>
            <Grid item xs={12}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <Autocomplete
                  id="combo-box-demo"
                  options={ModelData}
                  getOptionLabel={(option) => option.ACIKLAMA || ""}
                  value={ModelData.find(v => v.KUL_MODEL_KODU === KUL_MODEL_KODU) || null}
                  onChange={(event, newValue) => {
                    const fakeEvent = {
                      target: {
                        value: newValue ? newValue.KUL_MODEL_KODU : "0"
                      }
                    };
                    handleChangeModel(fakeEvent);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Model Seçiniz"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </CardContent>
        </Card>
        <br />
        <Box mb={3}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={() => setOpenBarkod(true)}
            startIcon={<CropFreeIcon />}
          >
            BARKOD İLE MALZEME ARA
          </Button>
        </Box>

        <Card elevation={3} style={{ position: 'relative' }}>
          {loading && (
            <Box className={classes.loaderWrapper}>
              <CircularProgress size={24} style={{ margin: '20px auto', display: 'block' }} />
            </Box>
          )}

          <Box className={classes.cardTitle}>
            <Typography variant="h6" color="textPrimary">
              Malzeme Bilgileri
            </Typography>
          </Box>
          <Divider />

          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                {KUL_MODEL_KODU === '0' ? (
                  <ProductMaterialSearch
                    setMalzeme={setMalzemeImage}
                    value={typeof MalzemeDataResim === 'object' ? MalzemeDataResim : null}
                    searchParam={SearchParamDetail}
                    searchProductCode={KUL_MODEL_KODU}
                  />
                ) : (
                  <FormControl variant="outlined" fullWidth className={classes.formControl}>
                    <Autocomplete
                      id="malzeme-select-autocomplete"
                      options={MalzemeData}
                      getOptionLabel={(option) => option.MALZEME_STOK_NO + '-' + option.ACIKLAMA || ""}
                      value={MalzemeData.find((p) => p.MALZEME_STOK_NO === MalzemeStokNoTekil) || null}
                      // Seçim yapıldığında çalışacak fonksiyon
                      onChange={(event, newValue) => {
                        // 1. Manuel bir event objesi oluşturuyoruz ki eski handleChange kırılmasın
                        const fakeEvent = {
                          target: {
                            name: "user_select",
                            value: newValue ? newValue.MALZEME_STOK_NO : "0" // Seçilen ID'yi gönderiyoruz
                          }
                        };
                        handleChangeMalzeme(fakeEvent);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Malzeme Seçiniz"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                      // Arama sırasında performans ve doğruluk için:
                      getOptionSelected={(option, value) => option.MALZEME_STOK_NO === value.MALZEME_STOK_NO}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Talep Edilen Adet"
                  type="number"
                  value={Adet}
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setAdet(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <QuantityIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>

          <Divider />

          <CardActions className={classes.actionArea}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => malzemeGosterResim(MalzemeStokNo)}
              startIcon={<ImageSearchIcon />}
              disabled={!MalzemeStokNo}
            >
              RESİM
            </Button>

            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={SendMaterialImageDetail}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
              disabled={loading}
            >
              GÖNDER
            </Button>
          </CardActions>
        </Card>
      </Container>

      {/* Popups & Dialogs */}
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />


      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <DialogTitle>
          <Typography variant="h5">Sistem Mesajı</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>{Uyari}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="contained">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default MaterialRequest;